export const GL_ACCOUNT_ERROR_MESSAGES = {
  ALREADY_EXISTS: "already exists",
} as const
